import React, { useEffect, useState } from "react";

import { useUserContext } from "../../context/User";
import {
  getAdoptStageCompIcon,
  getAdoptStageLoginIcon,
  getAdoptStageOverviewIcon,
} from "../../services/icons";
import AdoptCompatibility from "./AdoptCompatibility";
import AdoptLogin from "./AdoptLogin";
import AdoptOverview from "./AdoptOverview";

const stages = [
  {
    id: 1,
    title: "Login",
    desc: "",
    icon: (c: string | undefined) => getAdoptStageLoginIcon(c),
    component: <AdoptLogin />,
  },
  {
    id: 2,
    title: "Compatibility test",
    icon: (c: string | undefined) => getAdoptStageCompIcon(c),
    component: ({ pet, adoption, setStageById }) => (
      <AdoptCompatibility pet={pet} setStageById={setStageById} adoption={adoption} />
    ),
  },
  {
    id: 3,
    // title: "Adoption overview",
    icon: (c: string | undefined) => getAdoptStageOverviewIcon(c),
    component: ({ pet, adoption, setStageById }) => <AdoptOverview pet={pet} adoption={adoption} />,
  },
  // {
  //   id: 3,
  //   title: "Reservation",
  //   icon: (c: string | undefined) => getAdoptStageReservIcon(c),
  //   component: <>Reservation Content</>,
  // },
  // {
  //   id: 4,
  //   title: "Shelter review",
  //   icon: (c: string | undefined) => getAdoptStageShelterIcon(c),
  //   component: <>Shelter review Content</>,
  // },
  // {
  //   id: 5,
  //   title: "Payment",
  //   icon: (c: string | undefined) => getAdoptStagePayIcon(c),
  //   component: <>Payment Content</>,
  // },
  // {
  //   id: 6,
  //   title: "Adoption overview",
  //   icon: (c: string | undefined) => getAdoptStageOverviewIcon(c),
  //   component: <>Adoption overview Content</>,
  // },
];
const defaultStage = stages[0];

const AdoptStages = ({ pet, adoption }) => {
  const [stage, setStage] = useState(defaultStage);
  const [active, setActive] = useState([defaultStage]);

  const { user } = useUserContext();

  useEffect(() => {
    const accessToken = user.accessToken;
    if (!accessToken) {
      return;
    }

    setActive((prevState) => [...prevState, stages[1]]);

    if (adoption?.status === "succeeded") {
      setStage(stages[2]);
      return;
    }

    if (!adoption?.compatibility?.finish) {
      setStage(stages[1]);
    }
  }, [user, pet, adoption]);

  const checkIfActive = (st: number) => active.find((s) => s.id === st);

  const onChangeCurrentStage = (newStage: number) => {
    if (newStage < 1 || newStage > stages.length) {
      return;
    }

    if (!checkIfActive(newStage)) {
      return;
    }

    setStage(stages.find((s) => s.id === newStage) || defaultStage);
  };

  const addStageToActiveAndCurrentById = (id: number) => {
    const st = stages.find((s) => s.id === id);
    setActive((prevState) => [...prevState, st]);
    setStage(st);
  };

  return (
    <div>
      <div className="flex flex-row items-center justify-center gap-4">
        {stages.map((stg) => {
          return (
            <div
              key={stg.id}
              className={`flex w-[100px] justify-center border-b-[5px] border-theme-grey-5 ${stage.id === stg.id && "!border-theme-green-5"} ${checkIfActive(stg.id) && "cursor-pointer !border-theme-green-5"}`}
              onClick={() => onChangeCurrentStage(stg.id)}
            >
              <div className="mb-2">{stg.icon(stage.id === stg.id ? "#272624" : undefined)}</div>
            </div>
          );
        })}
      </div>
      <div className="mt-10 flex flex-col items-center gap-2">
        {stage.title && (
          <div className="font-bold text-theme-grey-9.5">
            {stage.id}. {stage.title}
          </div>
        )}
        <div className="">
          {typeof stage.component === "function"
            ? stage.component({
                pet,
                adoption,
                setStageById: addStageToActiveAndCurrentById,
              })
            : stage.component}
        </div>
      </div>
    </div>
  );
};

export default AdoptStages;
